// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import MyOrder from './MyOrder';

export default compose(
    connect(
        state => ( {
            user: state.global?.user || {},
        } ),
        dispatch => ( {} ),
    ),
)( MyOrder );
